// @react/hooks/useProjectComponent.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectComponentStore } from '@core/stores';

/**
 * React hook for ProjectComponent operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProjectComponent } from '@react/hooks';
 *
 * const ProjectComponentList = observer(() => {
 *   const store = useProjectComponent();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProjectComponent() {
  return projectComponentStore;
}
